import axios from "axios";
import { serverAddress } from "constants";

const axiosInstance = axios.create({
  baseURL: serverAddress,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("error",error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.err || "Request failed");
    }
    throw error;
  }
);
const token = localStorage.getItem("token");

const config = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
});

const organizationId = localStorage.getItem("organizationId");


export const fetchSalaries = async (employee_id, month, year, page, limit, token) => {
  try {
    const response = await axiosInstance.get(
      `/salary/get?organizationId=${organizationId}`,
      {
        params: {
          employee_id: employee_id ? Number(employee_id) : undefined,
          month: month ? Number(month) : undefined,
          year: year ? Number(year) : undefined,
          page: page || 1,
          limit: limit || 10,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200 && !response.data.error) {
      return response.data; // Returns salary details
    } else {
      throw new Error(response.data.message || "Error fetching salaries");
    }
  } catch (error) {
    console.error("Error in fetchSalaries:", error);
    throw error;
  }
};

export const calculateEmployeeSalary = async (employee_id, month, year, token) => {
  try {
    const requestBody = {
      employee_id: Number(employee_id),
      month: Number(month),
      year: Number(year),
    };

    const response = await axiosInstance.post(
      `/salary/calculate?organizationId=${organizationId}`,
      requestBody,
      config(token)
    );


    if (response.status === 200 && !response.data.error) {
      return response.data; // Returns the salary calculation details
    } else {
      return (response.data.msg || "Error calculating salary");
    }
  } catch (error) {
    console.error("Error in calculateEmployeeSalary:", error);
    throw error;
  }
};

export const calculateAllEmployeeSalary = async (month, year, token) => {
    try {
      const requestBody = {
        month: Number(month),
        year: Number(year),
      };
  
      const response = await axiosInstance.post(
        `/salary/calculateforall?organizationId=${organizationId}`,
        requestBody,
        config(token)
      );
  
      if (response.status === 200 && !response.data.error) {
        return response.data; // Returns the salary calculation details
      } else {
        throw new Error(response.data.msg || "Error calculating salary");
      }
    } catch (error) {
      console.error("Error in calculateEmployeeSalary:", error);
      throw error;
    }
  };
  



export default axiosInstance;
